<template>
  <el-dialog :visible.sync="dialogVisible" :destroy-on-close="true" @close="onclose" title="提示" top="10vh"
    class="dp-dialog">
    <div class="">
      <div class="main-page">
        <div class="revokebackgroundBox">
          <div class="main-contentBox">
            <div class="star-title">
              <span class="star"></span>补正提醒事项
            </div>
            <div class="contentBox tip-contentBox">
              <div class="textBox">
                1、你的复议申请已通过书面方式补正，请在收到书面补正通知后，按照书面补正通知的指引进行补正。<br/>
               <div style="text-indent: 1em"> 2、如你选择通过本系统进行补正，补正界面文本框中显示的内容仅为对你之前提交复议申请书的摘要，并不是你复议申请书的全部内容。你可在补正界面对文本框内容进行修改，补正复议申请书内容以你最终提交的为准。
              </div></div>
            </div>
            <div class="btnLists">
              <div @click="interApply" v-if="isShow" class="primary-btn">补正 <span v-if="!isShow"> ( {{ downNumber }} )
                </span> </div>
              <div class="gary-btn" v-else>补正 ( {{ downNumber }} ) </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@api/api'
export default {
  props: {
    applicantInfo: {
      default: () => { return [] },
      type: Array,
      required: true
    },
    caseOrderNo: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      checked: false,
      isShow: false,
      downNumber: 5, // 倒数字
      dialogVisible: false
    }
  },
  created () {

  },
  methods: {
    open () {
      this.dialogVisible = true
      this.startDownNumber()
    },
    onclose () {
      this.dialogVisible = false
    },
    // 倒计时
    startDownNumber () {
      this.isShow = false
      this.downNumber = 5
      var times = setInterval(() => {
        console.log('====================================')
        this.downNumber--
        if (this.downNumber <= 0) {
          this.isShow = true
          clearInterval(times)
        }
      }, 1000)
    },
    // 撤回
    interApply () {
      Api.correctionCheck({
          caseOrderNo: this.caseOrderNo
        }).then(({ data }) => {
          if(data.code == 0){
            
            this.dialogVisible = false
            this.$router.push({
              name: 'NewCase',
              query: {
                name: 'caseList',
                number: this.caseOrderNo,
                opera: 1
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .dp-dialog {
  ::v-deep .el-dialog {
    width:300px !important;

    .el-dialog__body {
      height: 300px !important;
      overflow-y: auto;
    }
  }
}
}

.dp-dialog {
  ::v-deep .el-dialog {
    width: 596px ;

    .el-dialog__body {
      height: 400px !important;
      overflow-y: auto;
    }
  }
}

.revokebackgroundBox {
  flex: 1;
  background-size: 104% 104%;
  background-position: -22px 0px !important;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.main-contentBox {
  .star-title {
    margin-bottom: 20px;
  }

  .tip-contentBox {
    padding: 20px;
    .textBox {
      padding: 0 20px;
      text-indent: 1em;
      line-height: 24px;
      .paragraph {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #333333;
        line-height: 36px;
      }

      .text-content {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #666666;
        line-height: 28px;
        margin-left: 30px;
      }
    }
  }

  .checked-text {
    margin-top: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}
</style>
